module.exports = __webpack_public_path__ + "static/media/reparaciones.e3122c2f.png";